import { useState } from "react";
import { useSelector } from "react-redux";

import { ComponentCurrentPoint, ComponentMembershipTier } from "@components";
import { IMembershipTier } from "@interfaces";
import { selectMerchant } from "@redux";

interface IProps {
    maintainPoint: number;
    firstTier: boolean;
    percent: number;
    date?: string;
    tierColor?: string;
    tierIcon?: string;
    isBalance?: boolean;
}

export const ModuleMemberShipTier = (props: IProps) => {
    //page hooks

    //page states
    const [membershipTier, setMembershipTier] = useState<IMembershipTier | undefined>();
    //redux states
    const { maintainPoint, firstTier, percent, date, tierColor, tierIcon, isBalance } = props;
    const { memberShipTiers } = useSelector(selectMerchant);

    const handleClickNext = (id: string) => {
        const index =
            memberShipTiers?.findIndex((membershipTier) => membershipTier._id === id) || 0;
        if (index >= 0 && memberShipTiers) {
            setMembershipTier(memberShipTiers[index]);
            document.body.style.overflow = "hidden";
            // dispatch(setToggleConfirm());
        }
    };

    const handleClose = () => {
        setMembershipTier(undefined);
        // dispatch(setToggleConfirm());
        document.body.style.overflow = "unset";
    };

    return (
        <>
            {memberShipTiers?.length !== 0 && (
                <>
                    <ComponentMembershipTier
                        handleClickNext={handleClickNext}
                        maintainPoint={maintainPoint}
                        firstTier={firstTier}
                        percent={percent}
                        date={date}
                        tierColor={tierColor}
                        tierIcon={tierIcon}
                        isBalance={isBalance}
                    />
                    {membershipTier && (
                        <ComponentCurrentPoint
                            membershipTier={membershipTier}
                            handleClose={handleClose}
                        />
                    )}
                </>
            )}
        </>
    );
};
